import { FC, useState } from "react";
import CustomButton from "ui/Button";
import { ICON_NAMES } from "utils/constant";
import { useTranslation } from "react-i18next";
import CustomDropDownList from "ui/dropDown";
import { UserListFilter } from "api/user";
import { Input } from "@progress/kendo-react-inputs";

interface CustomProps {
	pageSize: number;
	setFilterOptions: (options: UserListFilter) => void;
	filterOptions: UserListFilter;
	roles: any[];
	exportAsPDF: () => void;
	exportAsExcel: () => void;
}
const Filter: FC<CustomProps> = ({
	setFilterOptions,
	filterOptions,
	exportAsPDF,
	roles,
	...props
}) => {
	const { t } = useTranslation();
	const [filter, setFilter] = useState<UserListFilter>();

	const applyFilter = (field: keyof UserListFilter) => {
		const trimmedValue = (filter?.[field] || "").toString().trim();
		if (trimmedValue === filterOptions[field]) {
			return;
		}
		setFilterOptions({
			...filterOptions,
			[field]: trimmedValue,
			skip: 0,
		});
	};
	return (
		<div className="filter-container">
			<div className="filter-items user-list-filter-items">
				<div style={{ width: "170px" }}>
					<Input
						placeholder={t("FirstName")}
						value={filter?.firstname || ""}
						label={t("FirstName")}
						onChange={(e) => {
							setFilter({
								...filter,
								firstname: e.value,
							});
						}}
						onKeyDown={(e) => {
							if (e.key === "Enter") {
								applyFilter("firstname");
							}
						}}
						onBlur={() => applyFilter("firstname")}
						style={{ width: "100%" }}
					/>
				</div>
				<div style={{ width: "170px" }}>
					<Input
						placeholder={t("LastName")}
						value={filter?.lastname || ""}
						label={t("LastName")}
						onChange={(e) => {
							setFilter({
								...filter,
								lastname: e.value,
							});
						}}
						onKeyDown={(e) => {
							if (e.key === "Enter") applyFilter("lastname");
						}}
						onBlur={() => applyFilter("lastname")}
						style={{ width: "100%" }}
					/>
				</div>
				<div style={{ width: "170px" }}>
					<Input
						placeholder={t("Email")}
						value={filter?.email || ""}
						label={t("Email")}
						onChange={(e) => {
							setFilter({
								...filter,
								email: e.value,
							});
						}}
						onKeyDown={(e) => {
							if (e.key === "Enter") applyFilter("email");
						}}
						onBlur={() => applyFilter("email")}
						style={{ width: "100%" }}
					/>
				</div>
				<div style={{ width: "170px" }}>
					<CustomDropDownList
						onSelect={(role) => {
							setFilterOptions({
								...filterOptions,
								roleId: role.id,
								skip: 0,
							});
						}}
						data={roles}
						// value={{
						// 	id: filterOptions.statusId || null,
						// 	statusText: filterOptions.statusText || "choose Status",
						// }}
						dataItemKey="id"
						textField="name"
						label={t("Roles")}
						defaultItem={{ id: null, name: `${t("Choose")} ${t("Roles")}` }}
						className="height-inherit"
					/>
				</div>
			</div>
			<div className="filter-end-btn user-list-filter-end-btn">
				{/*<CustomButton*/}
				{/*	label={"PDF"}*/}
				{/*	onClick={() => exportAsPDF()}*/}
				{/*	iconName={ICON_NAMES.Download}*/}
				{/*/>*/}
				<CustomButton
					label={"Excel"}
					onClick={() => props.exportAsExcel()}
					iconName={ICON_NAMES.Download}
				/>
			</div>
		</div>
	);
};

export default Filter;
